"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = xhr;

require("core-js/modules/es6.promise");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

function dataFormat(obj) {
  return Object.keys(obj).reduce(function (arr, key, index) {
    arr[index] = "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]));
    return arr;
  }, []).join('&');
}

function xhr(url, params) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
  return new Promise(function (resolve, reject) {
    // eslint-disable-next-line
    var request = new XMLHttpRequest();

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status === 200 || request.status === 304) {
          var resp = JSON.parse(request.responseText);
          resolve(resp);
        } else {
          reject();
        }
      }
    };

    var paramsStr = dataFormat(params);

    if (type === 'POST') {
      request.open('POST', encodeURI(url), true);
      request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      request.send(paramsStr);
    } else {
      request.open('GET', encodeURI("".concat(url, "?").concat(paramsStr)), true);
      request.send(null);
    }
  });
}